var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubstitutionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C15.5229 0 20 4.47715 20 10C20 15.5228 15.5229 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0Z",
    fill: "#3FC078"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5558 9.78261C13.378 9.78261 13.2002 9.69565 13.0669 9.6087C12.978 9.47826 12.8891 9.30435 12.8891 9.13043C12.8891 8.95652 12.978 8.78261 13.0669 8.65217L13.7336 8.04348H4.66691C4.31136 8.04348 4.00024 7.73913 4.00024 7.3913C4.00024 7.04348 4.31136 6.73913 4.66691 6.73913H13.7336L13.1114 6.13043C12.978 6 12.8891 5.82609 12.8891 5.65217C12.8891 5.47826 12.978 5.30435 13.0669 5.17391C13.1558 5.04348 13.378 5 13.5558 5C13.7336 5 13.9114 5.08696 14.0447 5.17391L15.8225 6.91304C16.0891 7.17391 16.0891 7.56522 15.8225 7.82609L14.0447 9.56522C13.9114 9.69565 13.7336 9.78261 13.5558 9.78261ZM5.95544 14.8261C6.08877 14.9131 6.26655 15 6.44433 15C6.62211 15 6.79988 14.9131 6.88877 14.7826C7.15544 14.5218 7.15544 14.1305 6.88877 13.8696L6.26655 13.2609H15.3332C15.6888 13.2609 15.9999 12.9565 15.9999 12.6087C15.9999 12.2609 15.6888 11.9565 15.3332 11.9565H6.26655L6.93322 11.3044C7.19988 11.0435 7.19988 10.6522 6.93322 10.3913C6.79988 10.3044 6.62211 10.2174 6.44433 10.2174C6.26655 10.2174 6.08877 10.3044 5.95544 10.4348L4.17766 12.1739C3.91099 12.4348 3.91099 12.8261 4.17766 13.087L5.95544 14.8261Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstitutionIcon);
export default __webpack_public_path__ + "static/media/substitution-icon.4be1f2a8b7afce86491be6ab8dd00895.svg";
export { ForwardRef as ReactComponent };